// Auto-generated from design_ref/source/КНБК №1.xlsx (xl/media/* + EMF→PNG via inkscape).
// Файл-манифест ассетов КНБК — иконок элементов колонны.
// Регенерация: bash landing_lc_app/design_ref/source/extract_knbk_assets.sh

export type KnbkAsset = { name: string; w: number; h: number; bytes: number }

export const KNBK_ASSETS: KnbkAsset[] = [
  {
    "name": "image1.png",
    "w": 386,
    "h": 70,
    "bytes": 9721
  },
  {
    "name": "image2.png",
    "w": 23,
    "h": 219,
    "bytes": 907
  },
  {
    "name": "image3.png",
    "w": 60,
    "h": 85,
    "bytes": 13125
  },
  {
    "name": "image4.png",
    "w": 63,
    "h": 628,
    "bytes": 13691
  },
  {
    "name": "image5.png",
    "w": 25,
    "h": 64,
    "bytes": 475
  },
  {
    "name": "image6.png",
    "w": 29,
    "h": 221,
    "bytes": 339
  },
  {
    "name": "image7.png",
    "w": 24,
    "h": 221,
    "bytes": 1253
  },
  {
    "name": "image8.png",
    "w": 120,
    "h": 273,
    "bytes": 10960
  },
  {
    "name": "image9.png",
    "w": 3,
    "h": 10,
    "bytes": 227
  },
  {
    "name": "image10.png",
    "w": 156,
    "h": 187,
    "bytes": 14679
  },
  {
    "name": "image11.png",
    "w": 185,
    "h": 222,
    "bytes": 17499
  },
  {
    "name": "image12.png",
    "w": 20,
    "h": 89,
    "bytes": 545
  },
  {
    "name": "image13.png",
    "w": 2,
    "h": 2,
    "bytes": 141
  },
  {
    "name": "image14.png",
    "w": 29,
    "h": 18,
    "bytes": 928
  },
  {
    "name": "image15.png",
    "w": 2,
    "h": 10,
    "bytes": 200
  },
  {
    "name": "image16.png",
    "w": 73,
    "h": 126,
    "bytes": 21956
  },
  {
    "name": "image17.png",
    "w": 82,
    "h": 117,
    "bytes": 21434
  },
  {
    "name": "image18.png",
    "w": 29,
    "h": 41,
    "bytes": 711
  },
  {
    "name": "image19.jpeg",
    "w": 128,
    "h": 128,
    "bytes": 3953
  },
  {
    "name": "image20.png",
    "w": 29,
    "h": 27,
    "bytes": 1158
  },
  {
    "name": "image21.png",
    "w": 29,
    "h": 18,
    "bytes": 1180
  },
  {
    "name": "image22.png",
    "w": 28,
    "h": 32,
    "bytes": 697
  },
  {
    "name": "image23.jpeg",
    "w": 128,
    "h": 128,
    "bytes": 2729
  },
  {
    "name": "image24.png",
    "w": 87,
    "h": 122,
    "bytes": 3859
  },
  {
    "name": "image25.png",
    "w": 8,
    "h": 8,
    "bytes": 114
  },
  {
    "name": "image26.png",
    "w": 48,
    "h": 326,
    "bytes": 14304
  },
  {
    "name": "image27.jpeg",
    "w": 64,
    "h": 165,
    "bytes": 5255
  },
  {
    "name": "image28.png",
    "w": 46,
    "h": 483,
    "bytes": 3631
  },
  {
    "name": "image29.png",
    "w": 80,
    "h": 44,
    "bytes": 186
  },
  {
    "name": "image30.png",
    "w": 46,
    "h": 90,
    "bytes": 1476
  },
  {
    "name": "image31.png",
    "w": 170,
    "h": 856,
    "bytes": 11332
  },
  {
    "name": "image32.png",
    "w": 128,
    "h": 660,
    "bytes": 8710
  },
  {
    "name": "image33.jpeg",
    "w": 43,
    "h": 500,
    "bytes": 3339
  },
  {
    "name": "image34.png",
    "w": 1366,
    "h": 768,
    "bytes": 414385
  },
  {
    "name": "image35.png",
    "w": 63,
    "h": 441,
    "bytes": 17485
  },
  {
    "name": "image36.png",
    "w": 125,
    "h": 1558,
    "bytes": 93708
  },
  {
    "name": "image37.png",
    "w": 1366,
    "h": 768,
    "bytes": 198539
  },
  {
    "name": "image38.jpeg",
    "w": 62,
    "h": 64,
    "bytes": 2529
  },
  {
    "name": "image39.jpeg",
    "w": 1052,
    "h": 907,
    "bytes": 29929
  },
  {
    "name": "image40.jpeg",
    "w": 1576,
    "h": 1034,
    "bytes": 47284
  },
  {
    "name": "image41.png",
    "w": 120,
    "h": 210,
    "bytes": 45623
  },
  {
    "name": "image42.png",
    "w": 106,
    "h": 193,
    "bytes": 36286
  },
  {
    "name": "image43.jpeg",
    "w": 52,
    "h": 165,
    "bytes": 4814
  },
  {
    "name": "image44.png",
    "w": 76,
    "h": 301,
    "bytes": 5973
  },
  {
    "name": "image45.png",
    "w": 137,
    "h": 585,
    "bytes": 19944
  },
  {
    "name": "image46.png",
    "w": 653,
    "h": 143,
    "bytes": 30264
  },
  {
    "name": "image47.png",
    "w": 81,
    "h": 673,
    "bytes": 31936
  },
  {
    "name": "image48.png",
    "w": 91,
    "h": 680,
    "bytes": 28075
  },
  {
    "name": "image49.png",
    "w": 623,
    "h": 122,
    "bytes": 37521
  },
  {
    "name": "image50.png",
    "w": 63,
    "h": 201,
    "bytes": 7210
  },
  {
    "name": "image51.png",
    "w": 140,
    "h": 584,
    "bytes": 61617
  },
  {
    "name": "image52.png",
    "w": 1163,
    "h": 76,
    "bytes": 71561
  },
  {
    "name": "image53.png",
    "w": 91,
    "h": 337,
    "bytes": 14986
  },
  {
    "name": "image54.png",
    "w": 73,
    "h": 324,
    "bytes": 10779
  },
  {
    "name": "image55.png",
    "w": 155,
    "h": 312,
    "bytes": 13454
  },
  {
    "name": "image56.png",
    "w": 280,
    "h": 361,
    "bytes": 23502
  },
  {
    "name": "image57.png",
    "w": 483,
    "h": 606,
    "bytes": 105399
  },
  {
    "name": "image58.png",
    "w": 743,
    "h": 1404,
    "bytes": 218252
  },
  {
    "name": "image59.png",
    "w": 58,
    "h": 372,
    "bytes": 12824
  },
  {
    "name": "image60.jpeg",
    "w": 60,
    "h": 260,
    "bytes": 8480
  },
  {
    "name": "image61.png",
    "w": 146,
    "h": 379,
    "bytes": 15821
  },
  {
    "name": "image62.png",
    "w": 80,
    "h": 46,
    "bytes": 447
  },
  {
    "name": "image63.jpeg",
    "w": 141,
    "h": 191,
    "bytes": 6166
  },
  {
    "name": "image64.png",
    "w": 80,
    "h": 49,
    "bytes": 242
  },
  {
    "name": "image65.png",
    "w": 80,
    "h": 38,
    "bytes": 560
  },
  {
    "name": "image66.jpeg",
    "w": 69,
    "h": 376,
    "bytes": 15840
  },
  {
    "name": "image67.jpeg",
    "w": 44,
    "h": 238,
    "bytes": 7510
  },
  {
    "name": "image68.png",
    "w": 19,
    "h": 182,
    "bytes": 992
  },
  {
    "name": "image69.png",
    "w": 34,
    "h": 481,
    "bytes": 1112
  },
  {
    "name": "image70.png",
    "w": 59,
    "h": 142,
    "bytes": 324
  },
  {
    "name": "image71.png",
    "w": 80,
    "h": 306,
    "bytes": 1028
  },
  {
    "name": "image72.png",
    "w": 80,
    "h": 50,
    "bytes": 1044
  },
  {
    "name": "image73.png",
    "w": 474,
    "h": 609,
    "bytes": 100732
  },
  {
    "name": "image74.png",
    "w": 452,
    "h": 603,
    "bytes": 111953
  },
  {
    "name": "image75.png",
    "w": 428,
    "h": 694,
    "bytes": 110580
  },
  {
    "name": "image76.png",
    "w": 848,
    "h": 291,
    "bytes": 71953
  },
  {
    "name": "image77.png",
    "w": 517,
    "h": 300,
    "bytes": 77935
  },
  {
    "name": "image78.png",
    "w": 269,
    "h": 257,
    "bytes": 25054
  },
  {
    "name": "image79.png",
    "w": 83,
    "h": 248,
    "bytes": 1778
  },
  {
    "name": "image80.png",
    "w": 62,
    "h": 256,
    "bytes": 10472
  },
  {
    "name": "image81.png",
    "w": 74,
    "h": 391,
    "bytes": 13725
  },
  {
    "name": "image82.png",
    "w": 75,
    "h": 109,
    "bytes": 8117
  },
  {
    "name": "image83.png",
    "w": 76,
    "h": 453,
    "bytes": 25261
  },
  {
    "name": "image84.jpeg",
    "w": 72,
    "h": 478,
    "bytes": 16857
  },
  {
    "name": "image85.png",
    "w": 94,
    "h": 190,
    "bytes": 17366
  },
  {
    "name": "image86.png",
    "w": 55,
    "h": 81,
    "bytes": 10757
  },
  {
    "name": "image87.png",
    "w": 57,
    "h": 419,
    "bytes": 8500
  },
  {
    "name": "image88.png",
    "w": 92,
    "h": 258,
    "bytes": 24516
  },
  {
    "name": "image89.png",
    "w": 63,
    "h": 333,
    "bytes": 20849
  },
  {
    "name": "image90.png",
    "w": 84,
    "h": 226,
    "bytes": 15155
  },
  {
    "name": "image91.png",
    "w": 57,
    "h": 375,
    "bytes": 35518
  },
  {
    "name": "image92.png",
    "w": 109,
    "h": 225,
    "bytes": 19899
  },
  {
    "name": "image93.png",
    "w": 70,
    "h": 226,
    "bytes": 15445
  },
  {
    "name": "image94.png",
    "w": 76,
    "h": 323,
    "bytes": 16654
  },
  {
    "name": "image95.png",
    "w": 78,
    "h": 371,
    "bytes": 31223
  },
  {
    "name": "image96.jpeg",
    "w": 95,
    "h": 448,
    "bytes": 16746
  },
  {
    "name": "image97.png",
    "w": 57,
    "h": 446,
    "bytes": 35038
  },
  {
    "name": "image98.png",
    "w": 61,
    "h": 450,
    "bytes": 18091
  },
  {
    "name": "image99.png",
    "w": 76,
    "h": 325,
    "bytes": 22052
  },
  {
    "name": "image100.png",
    "w": 58,
    "h": 284,
    "bytes": 22926
  },
  {
    "name": "image101.png",
    "w": 58,
    "h": 147,
    "bytes": 9763
  },
  {
    "name": "image102.png",
    "w": 59,
    "h": 146,
    "bytes": 8991
  },
  {
    "name": "image103.png",
    "w": 66,
    "h": 480,
    "bytes": 38384
  },
  {
    "name": "image104.png",
    "w": 59,
    "h": 745,
    "bytes": 29212
  },
  {
    "name": "image105.png",
    "w": 130,
    "h": 222,
    "bytes": 6552
  },
  {
    "name": "image106.png",
    "w": 70,
    "h": 186,
    "bytes": 6284
  },
  {
    "name": "image107.png",
    "w": 46,
    "h": 117,
    "bytes": 8833
  },
  {
    "name": "image108.png",
    "w": 60,
    "h": 134,
    "bytes": 4587
  },
  {
    "name": "image109.png",
    "w": 48,
    "h": 127,
    "bytes": 3918
  },
  {
    "name": "image110.png",
    "w": 47,
    "h": 186,
    "bytes": 16534
  },
  {
    "name": "image111.png",
    "w": 48,
    "h": 95,
    "bytes": 4320
  },
  {
    "name": "image112.png",
    "w": 39,
    "h": 287,
    "bytes": 16039
  },
  {
    "name": "image113.png",
    "w": 82,
    "h": 284,
    "bytes": 19016
  },
  {
    "name": "image114.png",
    "w": 59,
    "h": 188,
    "bytes": 21647
  },
  {
    "name": "image115.png",
    "w": 39,
    "h": 231,
    "bytes": 13646
  },
  {
    "name": "image116.png",
    "w": 63,
    "h": 182,
    "bytes": 12512
  },
  {
    "name": "image117.png",
    "w": 60,
    "h": 182,
    "bytes": 11790
  },
  {
    "name": "image118.png",
    "w": 57,
    "h": 751,
    "bytes": 33417
  },
  {
    "name": "image119.png",
    "w": 93,
    "h": 567,
    "bytes": 28328
  },
  {
    "name": "image120.png",
    "w": 59,
    "h": 251,
    "bytes": 20055
  },
  {
    "name": "image121.png",
    "w": 76,
    "h": 263,
    "bytes": 12865
  },
  {
    "name": "image122.png",
    "w": 55,
    "h": 263,
    "bytes": 29344
  },
  {
    "name": "image123.png",
    "w": 76,
    "h": 431,
    "bytes": 19200
  },
  {
    "name": "image124.png",
    "w": 59,
    "h": 113,
    "bytes": 4418
  },
  {
    "name": "image125.png",
    "w": 59,
    "h": 301,
    "bytes": 25144
  },
  {
    "name": "image126.png",
    "w": 79,
    "h": 300,
    "bytes": 18985
  },
  {
    "name": "image127.png",
    "w": 57,
    "h": 459,
    "bytes": 5546
  },
  {
    "name": "image128.png",
    "w": 73,
    "h": 265,
    "bytes": 21914
  },
  {
    "name": "image129.jpeg",
    "w": 92,
    "h": 258,
    "bytes": 11057
  },
  {
    "name": "image130.jpeg",
    "w": 67,
    "h": 273,
    "bytes": 9568
  },
  {
    "name": "image131.jpeg",
    "w": 32,
    "h": 282,
    "bytes": 5478
  },
  {
    "name": "image132.jpeg",
    "w": 105,
    "h": 586,
    "bytes": 16049
  },
  {
    "name": "image133.jpeg",
    "w": 59,
    "h": 284,
    "bytes": 8697
  },
  {
    "name": "image134.png",
    "w": 63,
    "h": 149,
    "bytes": 5510
  },
  {
    "name": "image135.png",
    "w": 59,
    "h": 280,
    "bytes": 24149
  },
  {
    "name": "image136.png",
    "w": 59,
    "h": 444,
    "bytes": 5533
  },
  {
    "name": "image137.png",
    "w": 92,
    "h": 301,
    "bytes": 47237
  },
  {
    "name": "image138.png",
    "w": 63,
    "h": 183,
    "bytes": 7785
  },
  {
    "name": "image139.png",
    "w": 83,
    "h": 630,
    "bytes": 50983
  },
  {
    "name": "image140.png",
    "w": 98,
    "h": 597,
    "bytes": 29782
  },
  {
    "name": "image141.png",
    "w": 55,
    "h": 226,
    "bytes": 19482
  },
  {
    "name": "image142.jpeg",
    "w": 128,
    "h": 128,
    "bytes": 6779
  },
  {
    "name": "image143.png",
    "w": 104,
    "h": 333,
    "bytes": 32734
  },
  {
    "name": "image144.png",
    "w": 80,
    "h": 457,
    "bytes": 42029
  },
  {
    "name": "image145.png",
    "w": 80,
    "h": 154,
    "bytes": 19416
  },
  {
    "name": "image146.png",
    "w": 57,
    "h": 576,
    "bytes": 31738
  },
  {
    "name": "image147.png",
    "w": 92,
    "h": 300,
    "bytes": 27422
  },
  {
    "name": "image148.png",
    "w": 44,
    "h": 214,
    "bytes": 7854
  }
]
